import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-dynamic-icon',
  templateUrl: './dynamic-icon.component.html',
  styleUrls: ['./dynamic-icon.component.scss'],
  standalone: false,
})
export class DynamicIconComponent implements OnChanges {
  @Input() name!: string;
  @Input() size: string = '18px';
  @Input() color: string = '#0085c7';

  iconPath?: string;
  iconSvg?: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['name'] || changes['size'] || changes['color']) {
      this.resolveIcon();
    }
  }

  private resolveIcon(): void {
    this.iconPath = undefined;
    this.iconSvg = undefined;

    if (!this.name) {
      return;
    }

    if (this.name.startsWith('sidebar:')) {
      const iconName = this.name.split(':')[1];
      this.iconPath = `assets/images/sidebar-icons/${iconName}.svg`;
      return;
    }

    if (this.name.startsWith('custom:')) {
      const iconName = this.name.split(':')[1];
      this.iconPath = `assets/images/app-icons/${iconName}.svg`;
      return;
    }

    this.iconSvg = this.sanitizer.bypassSecurityTrustHtml(
      `<mat-icon>${this.name}</mat-icon>`
    );
  }
}
